// 中文语言包（默认）
export default {
  // 检测部位
  part: {
    '车头': '车头',
    '发动机舱': '发动机舱',
    '左前车身': '左前车身',
    '左前内饰': '左前内饰',
    '左后车身': '左后车身',
    '左后内饰': '左后内饰',
    '车尾': '车尾',
    '后备箱内部': '后备箱内部',
    '右后车身': '右后车身',
    '右后内饰': '右后内饰',
    '右前车身': '右前车身',
    '右前内饰': '右前内饰',
    '机电': '机电',
    '新能源检测': '新能源检测',
    '骨架': '骨架',
    '外观': '外观',
    '内饰': '内饰',
    '其它': '其它',
    '其他': '其他',
    '水渍残留点': '水渍残留点',
  },

  // 损伤等级颜色
  damageLevel: {
    '轻微损伤': '轻微损伤',
    '严重损伤': '严重损伤',
    '预检异常': '预检异常',
  },

  // 评分说明
  scoreRemark: {
    '车辆结构件与加强件均无因事故造成的损伤': '车辆结构件与加强件均无因事故造成的损伤',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤',
    '车辆结构件有因事故造成的损伤': '车辆结构件有因事故造成的损伤',
    '外观极差': '外观极差',
    '内饰极差': '内饰极差',
    '外观较差': '外观较差',
    '内饰较差': '内饰较差',
    '外观一般': '外观一般',
    '内饰一般': '内饰一般',
    '外观较好': '外观较好',
    '内饰较好': '内饰较好',
    '外观准新': '外观准新',
    '内饰准新': '内饰准新',
  },

  // 检测项名称
  inspectionItem: {
    '左前大灯': '左前大灯',
    '左前雾灯': '左前雾灯',
    '前底盘': '前底盘',
    '前保险杠': '前保险杠',
    '中网': '中网',
    '发动机舱盖外侧': '发动机舱盖外侧',
    '发动机舱盖内侧': '发动机舱盖内侧',
    '水箱框架': '水箱框架',
    '前防撞梁': '前防撞梁',
    '左前纵梁': '左前纵梁',
    '左前翼子板骨架': '左前翼子板骨架',
    '左前减震器支座': '左前减震器支座',
    '防火墙': '防火墙',
    '车架号': '车架号',
    '右前减震器支座': '右前减震器支座',
    '右前翼子板骨架': '右前翼子板骨架',
    '右前纵梁': '右前纵梁',
    '发动机变速箱及附件': '发动机变速箱及附件',
    '机油': '机油',
    '防冻液': '防冻液',
    '刹车油': '刹车油',
    '电池': '电池',
    '皮带': '皮带',
    '保险丝盒': '保险丝盒',
    '发动机线束': '发动机线束',
    '左前轮胎': '左前轮胎',
    '左前轮毂': '左前轮毂',
    '左前避震器': '左前避震器',
    '左前轮内衬罩': '左前轮内衬罩',
    '左前翼子板': '左前翼子板',
    '左后视镜': '左后视镜',
    '前风挡玻璃': '前风挡玻璃',
    '左A柱外侧': '左A柱外侧',
    '左前车顶': '左前车顶',
    '左前门玻璃': '左前门玻璃',
    '左前门外侧': '左前门外侧',
    '左前门裙边外侧': '左前门裙边外侧',
    '左前门内侧': '左前门内侧',
    '左前门内饰（含胶条）': '左前门内饰（含胶条）',
    '左A柱内侧': '左A柱内侧',
    '左前门裙边内侧': '左前门裙边内侧',
    '主驾座椅区域': '主驾座椅区域',
    '主驾座椅滑轨': '主驾座椅滑轨',
    '主驾安全带': '主驾安全带',
    '左前地毯（含周边饰条、饰板）': '左前地毯（含周边饰条、饰板）',
    '转向管柱': '转向管柱',
    '方向盘': '方向盘',
    '仪表盘': '仪表盘',
    '中控台': '中控台',
    '前排扶手区域': '前排扶手区域',
    '主驾仪表台': '主驾仪表台',
    '左A柱内饰板': '左A柱内饰板',
    '左前顶棚（含前排天窗饰板、遮阳板）': '左前顶棚（含前排天窗饰板、遮阳板）',
    '前排天窗': '前排天窗',
    '内后视镜区域': '内后视镜区域',
    '左后轮胎': '左后轮胎',
    '左后轮毂': '左后轮毂',
    '左后避震器': '左后避震器',
    '左后轮内衬罩': '左后轮内衬罩',
    '左后翼子板': '左后翼子板',
    '左C柱外侧': '左C柱外侧',
    '左后车顶': '左后车顶',
    '左B柱外侧': '左B柱外侧',
    '左后门玻璃': '左后门玻璃',
    '左后门外侧': '左后门外侧',
    '左后门裙边外侧': '左后门裙边外侧',
    '左后门内侧': '左后门内侧',
    '左后门内饰（含胶条）': '左后门内饰（含胶条）',
    '左C柱内侧': '左C柱内侧',
    '左B柱内侧': '左B柱内侧',
    '左后门裙边内侧': '左后门裙边内侧',
    '左后座椅区域': '左后座椅区域',
    '左后座椅滑轨': '左后座椅滑轨',
    '左后安全带': '左后安全带',
    '左后地毯（含周边饰条、饰板）': '左后地毯（含周边饰条、饰板）',
    '后排扶手区域': '后排扶手区域',
    '左B柱内饰板': '左B柱内饰板',
    '左C柱内饰板': '左C柱内饰板',
    '左后顶棚（含后排天窗饰板）': '左后顶棚（含后排天窗饰板）',
    '后排天窗': '后排天窗',
    '后风挡玻璃': '后风挡玻璃',
    '左D柱外侧': '左D柱外侧',
    '右D柱外侧': '右D柱外侧',
    '后备箱盖外侧': '后备箱盖外侧',
    '左后尾灯': '左后尾灯',
    '右后尾灯': '右后尾灯',
    '后保险杠': '后保险杠',
    '后防撞梁': '后防撞梁',
    '左后纵梁': '左后纵梁',
    '右后纵梁': '右后纵梁',
    '后底盘': '后底盘',
    '后备箱盖内侧': '后备箱盖内侧',
    '后备箱盖内饰板（含胶条）': '后备箱盖内饰板（含胶条）',
    '后部导水槽': '后部导水槽',
    '左D柱内饰板': '左D柱内饰板',
    '左D柱内侧': '左D柱内侧',
    '右D柱内饰板': '右D柱内饰板',
    '右D柱内侧': '右D柱内侧',
    '后窗台板': '后窗台板',
    '后备箱内饰（含胶条、地毯、周边饰条、饰板）': '后备箱内饰（含胶条、地毯、周边饰条、饰板）',
    '后围板': '后围板',
    '备胎轮胎': '备胎轮胎',
    '备胎轮毂': '备胎轮毂',
    '工具': '工具',
    '后备箱底板': '后备箱底板',
    '左后翼子板骨架(包含减震器支座)': '左后翼子板骨架(包含减震器支座)',
    '右后翼子板骨架(包含减震器支座)': '右后翼子板骨架(包含减震器支座)',
    '右后轮胎': '右后轮胎',
    '右后轮毂': '右后轮毂',
    '右后避震器': '右后避震器',
    '右后轮内衬罩': '右后轮内衬罩',
    '右后翼子板': '右后翼子板',
    '右C柱外侧': '右C柱外侧',
    '右后车顶': '右后车顶',
    '右B柱外侧': '右B柱外侧',
    '右后门玻璃': '右后门玻璃',
    '右后门外侧': '右后门外侧',
    '右后门裙边外侧': '右后门裙边外侧',
    '右后门内侧': '右后门内侧',
    '右后门内饰（含胶条）': '右后门内饰（含胶条）',
    '右C柱内侧': '右C柱内侧',
    '右B柱内侧': '右B柱内侧',
    '右后门裙边内侧': '右后门裙边内侧',
    '右后座椅区域': '右后座椅区域',
    '右后座椅滑轨': '右后座椅滑轨',
    '右后安全带': '右后安全带',
    '右后地毯（含周边饰条、饰板）': '右后地毯（含周边饰条、饰板）',
    '右B柱内饰板': '右B柱内饰板',
    '右C柱内饰板': '右C柱内饰板',
    '右后顶棚': '右后顶棚',
    '右A柱外侧': '右A柱外侧',
    '右前车顶': '右前车顶',
    '右前门玻璃': '右前门玻璃',
    '右前门外侧': '右前门外侧',
    '右前门裙边外侧': '右前门裙边外侧',
    '右前门内侧': '右前门内侧',
    '右前门内饰（含胶条）': '右前门内饰（含胶条）',
    '右A柱内侧': '右A柱内侧',
    '右前门裙边内侧': '右前门裙边内侧',
    '副驾座椅区域': '副驾座椅区域',
    '副驾座椅滑轨': '副驾座椅滑轨',
    '副驾安全带': '副驾安全带',
    '右前地毯（含周边饰条、饰板）': '右前地毯（含周边饰条、饰板）',
    '副驾仪表台': '副驾仪表台',
    '右A柱内饰板': '右A柱内饰板',
    '杂物箱': '杂物箱',
    '右前顶棚（含前排天窗饰板、遮阳板）': '右前顶棚（含前排天窗饰板、遮阳板）',
    '右前轮胎': '右前轮胎',
    '右前轮毂': '右前轮毂',
    '右前避震器': '右前避震器',
    '右前轮内衬罩': '右前轮内衬罩',
    '右前翼子板': '右前翼子板',
    '右后视镜': '右后视镜',
    '右前大灯': '右前大灯',
    '右前雾灯': '右前雾灯',
    '启动': '启动',
    '变速箱': '变速箱',
    '排烟': '排烟',
    '无钥匙进入': '无钥匙进入',
    '仪表盘功能自检': '仪表盘功能自检',
    '转向助力': '转向助力',
    '电动后视镜功能': '电动后视镜功能',
    '中控锁': '中控锁',
    '电动吸合门': '电动吸合门',
    '电动座椅': '电动座椅',
    '座椅记忆': '座椅记忆',
    '座椅加热': '座椅加热',
    '座椅通风': '座椅通风',
    '座椅按摩': '座椅按摩',
    '主驾驶电动门窗总控': '主驾驶电动门窗总控',
    '灯光系统': '灯光系统',
    '前驻车雷达': '前驻车雷达',
    '后驻车雷达': '后驻车雷达',
    '倒车影像': '倒车影像',
    '全景摄像头': '全景摄像头',
    '可变悬架': '可变悬架',
    '车载冰箱': '车载冰箱',
    '室内灯': '室内灯',
    '天窗': '天窗',
    '雨刷': '雨刷',
    '多功能方向盘': '多功能方向盘',
    '方向盘换挡拨片': '方向盘换挡拨片',
    '方向盘加热': '方向盘加热',
    '方向盘记忆': '方向盘记忆',
    '空调': '空调',
    '电动门': '电动门',
    '电动车窗': '电动车窗',
    '后排电动遮阳帘': '后排电动遮阳帘',
    '后排液晶屏': '后排液晶屏',
    '玻璃顶电动饰板': '玻璃顶电动饰板',
    '硬顶敞篷': '硬顶敞篷',
    '发动机': '发动机',
    '多媒体系统': '多媒体系统',
    '动力电池包安装点': '动力电池包安装点',
    '动力电池包': '动力电池包',
    '驱动电机(可见部分)': '驱动电机(可见部分)',
    '逆变器(可见部分)': '逆变器(可见部分)',
    '车身高压线束(可见部分)': '车身高压线束(可见部分)',
    '随车充电枪': '随车充电枪',
    '车辆充电口': '车辆充电口',
    '增程器': '增程器',
    '动力系统故障码': '动力系统故障码',
    '车辆充电故障': '车辆充电故障',
  },

  // 缺陷名称
  defect: {
    '安装不良': '安装不良',
    '常转': '常转',
    '超出上限': '超出上限',
    '闯档': '闯档',
    '篡改': '篡改',
    '打齿异响': '打齿异响',
    '打滑': '打滑',
    '打磨': '打磨',
    '灯内异物': '灯内异物',
    '低于下限': '低于下限',
    '断裂': '断裂',
    '钣金修复': '钣金修复',
    '改装': '改装',
    '更换': '更换',
    '功能失效': '功能失效',
    '鼓包': '鼓包',
    '故障': '故障',
    '后打胶': '后打胶',
    '花屏': '花屏',
    '划痕': '划痕',
    '划伤': '划伤',
    '晃动': '晃动',
    '变形': '变形',
    '浑浊': '浑浊',
    '胶套损坏': '胶套损坏',
    '胶体异常': '胶体异常',
    '胶条异常': '胶条异常',
    '卡滞': '卡滞',
    '空转': '空转',
    '老化': '老化',
    '裂纹': '裂纹',
    '冒白烟': '冒白烟',
    '冒黑烟': '冒黑烟',
    '不出风': '不出风',
    '冒蓝烟': '冒蓝烟',
    '霉斑': '霉斑',
    '磨损': '磨损',
    '泥沙': '泥沙',
    '喷漆': '喷漆',
    '偏磨': '偏磨',
    '破裂': '破裂',
    '破损': '破损',
    '启动困难': '启动困难',
    '气囊爆裂': '气囊爆裂',
    '不跳档': '不跳档',
    '切割': '切割',
    '缺失': '缺失',
    '缺损': '缺损',
    '缺线': '缺线',
    '入档困难': '入档困难',
    '色差': '色差',
    '烧烫': '烧烫',
    '渗水': '渗水',
    '渗油': '渗油',
    '失效': '失效',
    '不制冷': '不制冷',
    '水雾': '水雾',
    '松动': '松动',
    '松旷': '松旷',
    '损坏': '损坏',
    '损伤': '损伤',
    '塌陷': '塌陷',
    '调节失效': '调节失效',
    '贴膜起泡': '贴膜起泡',
    '脱档': '脱档',
    '污渍': '污渍',
    '不走车': '不走车',
    '响应慢': '响应慢',
    '修复': '修复',
    '锈蚀': '锈蚀',
    '异味': '异味',
    '异响': '异响',
    '怠速不稳': '怠速不稳',
    '怠速过高': '怠速过高',
    '给不上油': '给不上油',
    '加速抖动': '加速抖动',
    '缺缸': '缺缸',
    '部件缺失': '部件缺失',
    '气门异响': '气门异响',
    '内部异响': '内部异响',
    '轮组异响': '轮组异响',
    '窜气': '窜气',
    '排气异响': '排气异响',
    '水渍': '水渍',
    '凹陷': '凹陷',
    '车门更换': '车门更换',
    '拆卸': '拆卸',
    '后盖更换': '后盖更换',
    '机盖更换': '机盖更换',
    '内饰更换': '内饰更换',
    '焊接': '焊接',
    '开裂': '开裂',
    '剐蹭划伤': '剐蹭划伤',
    '渗漏': '渗漏',
    '火烧': '火烧',
    '抖动': '抖动',
    '动力电池故障': '动力电池故障',
    '驱动电机故障': '驱动电机故障',
    '其他': '其他',
    '快充故障': '快充故障',
    '慢充故障': '慢充故障',
    '过火': '过火',
    '缺气': '缺气',
  },

  // 等级
  grade: {
    'A': 'A级',
    'B': 'B级',
    'C': 'C级',
    'D': 'D级',
  },

  // 综合描述模板关键词
  description: {
    '外观无换件': '外观无换件',
    '外观原漆': '外观原漆',
    '外观无需整备成本': '外观无需整备成本',
    '内饰正常使用痕迹': '内饰正常使用痕迹',
    '车辆无骨架损伤': '车辆无骨架损伤',
    '发动机工况无异常': '发动机工况无异常',
    '变速器原地试车无异常': '变速器原地试车无异常',
  },

  // 通用
  common: {
    '项': '项',
    '项异常': '项异常',
    '分': '分',
    '级': '级',
    '检测': '检测',
    '图片': '图片',
    '加载失败': '加载失败',
    '加载中...': '加载中...',
  },

  // 页面标题
  title: {
    '车况检测': '车况检测',
    '综合描述': '综合描述',
    '综合': '综合',
  },

  // 提示文案
  tips: {
    '源于出险数据': '源于出险数据',
    '车辆是否曾进水(漏水/涉水/水泡)': '车辆是否曾进水(漏水/涉水/水泡)',
    '是': '是',
    '否': '否',
    '查看原图': '查看原图',
  },

  // 评分规则标题
  ruleTitle: {
    '外观评分规则': '外观评分规则',
    '骨架评级规则': '骨架评级规则',
    '内饰评分规则': '内饰评分规则',
    '综合评级规则': '综合评级规则',
  },

  // 外观评分说明
  exteriorRule: {
    '外观准新': '外观准新',
    '外观较好': '外观较好',
    '外观一般': '外观一般',
    '外观较差': '外观较差',
    '外观极差': '外观极差',
  },

  // 内饰评分说明
  interiorRule: {
    '内饰准新': '内饰准新',
    '内饰较好': '内饰较好',
    '内饰一般': '内饰一般',
    '内饰较差': '内饰较差',
    '内饰极差': '内饰极差',
  },

  // 骨架评级说明
  skeletonRule: {
    '车辆结构件与加强件均无因事故造成的损伤': '车辆结构件与加强件均无因事故造成的损伤',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤',
    '车辆结构件有因事故造成的损伤': '车辆结构件有因事故造成的损伤',
  },

  // 综合评级说明
  overallRule: {
    '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。': '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。',
    '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。': '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。',
    '骨架等级≥B，外观评分＞40，内饰评分＞40': '骨架等级≥B，外观评分＞40，内饰评分＞40',
    '骨架等级≥C，外观评分≥70，内饰评分≥70': '骨架等级≥C，外观评分≥70，内饰评分≥70',
    '骨架等级≥D，外观评分≥60，内饰评分≥50': '骨架等级≥D，外观评分≥60，内饰评分≥50',
    '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。': '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。',
    '骨架等级≥D，外观评分<50，内饰评分<40': '骨架等级≥D，外观评分<50，内饰评分<40',
  }
}
